import { apiClient } from '../../../../lib/api/client';
import type {
  ContactCategoryDetail,
  ContactCategoryFormValues,
  ContactCategoryListItem,
} from '../types';

export async function getContactCategories(): Promise<ContactCategoryListItem[]> {
  const response = await apiClient.get<ContactCategoryListItem[]>('/settings/contact-categories');
  return response.data;
}

export async function getContactCategoryById(id: number): Promise<ContactCategoryDetail> {
  const response = await apiClient.get<ContactCategoryDetail>(`/settings/contact-categories/${id}`);
  return response.data;
}

export async function createContactCategory(data: ContactCategoryFormValues): Promise<{ id: number }> {
  const response = await apiClient.post<{ id: number }>('/settings/contact-categories', {
    label: data.label,
    sortOrder: data.sortOrder,
    customerSegmentId: data.customerSegmentId,
    isActive: data.isActive,
  });
  return response.data;
}

export async function deleteContactCategory(id: number): Promise<void> {
  await apiClient.delete(`/settings/contact-categories/${id}`);
}

export async function updateContactCategory(id: number, data: ContactCategoryFormValues): Promise<void> {
  await apiClient.put(`/settings/contact-categories/${id}`, {
    label: data.label,
    sortOrder: data.sortOrder,
    customerSegmentId: data.customerSegmentId,
    isActive: data.isActive,
  });
}
